import * as React from 'react';
import * as classnames from 'classnames';

interface Props {
	children: React.ReactNode;
	className?: string;
}

const BoundedContainer: React.SFC<Props> = ({children, className}) => {
	return <div className={classnames('bounded', className)}>
		{children}
	</div>;
};

export default BoundedContainer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/widgets/BoundedContainer.tsx